import { render, staticRenderFns } from "./thong-ke-tien-te.vue?vue&type=template&id=775cc5ff&"
import script from "./thong-ke-tien-te.vue?vue&type=script&lang=js&"
export * from "./thong-ke-tien-te.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../boss_taobao/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../boss_taobao/admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VContainer,VDataTable,VDatePicker,VEditDialog,VFlex,VLayout,VMenu,VTextField})
